import { createAction, props } from '@ngrx/store';
import { TicketCounsel } from 'src/app/travelx/models/ticket-counsel.model';
import { TicketDetails } from 'src/app/travelx/models/ticket-details.model';
import { TicketEmployee } from 'src/app/travelx/models/ticket-employee.model';
import { TicketHistory } from 'src/app/travelx/models/ticket-history.model';
import { TicketTaskItemNoteHistory } from 'src/app/travelx/models/ticket-task-item-note-history.model';
import { TicketTaskItem } from 'src/app/travelx/models/ticket-task-item.model';
import { TicketCategory } from 'src/app/travelx/models/ticket-category.model';
import { CountryState } from 'src/app/shared/models/lookup-country-states.model';
import { TicketUrgency } from 'src/app/travelx/models/ticket-urgency.model';
import { TicketCandidateContract } from 'src/app/travelx/models/ticket-candidate-contract.model';
import { TicketContract } from 'src/app/travelx/models/ticket-contract.model';
import { TicketContractLookups } from 'src/app/travelx/models/ticket-contract-lookups.model';
import { TaskUpdateRequest } from 'src/app/travelx/models/task-update-request.model';
import { TicketAttachments } from 'src/app/travelx/models/ticket-attachments.model';
import { TicketFilesUpload } from 'src/app/travelx/models/ticket-files-upload.model';
import { TicketCandidate } from 'src/app/travelx/models/ticket-candidate.model';
import { TicketCreate } from 'src/app/travelx/models/ticket-create.model';
import { TicketSettingsCategoryType } from 'src/app/travelx/models/ticket-settings-category-type.model';
import { TicketSettingsCategory } from 'src/app/travelx/models/ticket-settings-category.model';
import { TravelContract } from 'src/app/travel-contracts/travel-contracts-grid/models/travel-contract';
import { OptionModel } from 'src/app/shared/grid/filters/option.model';
import { TicketTagType } from 'src/app/travelx/models/ticket-tag-type.model';
import { StaffingAdvisoryFromTicketRequest } from 'src/app/travelx/models/staffing-advisory-from-ticket-request.model';

export const loadTicketDetails = createAction(
    '[TICKET DETAILS COMPONENT] Load Ticket Details',
    props<{ ticketId: number }>()
);
export const loadTicketDetailsSuccess = createAction(
    '[TICKET DETAILS API] Load Ticket Details Successfully',
    props<{ ticketDetails: TicketDetails }>()
);
export const loadTicketDetailsFailure = createAction(
    '[TICKET DETAILS API] Load Ticket Details Failure',
    props<{ error: unknown; isForbidden: boolean }>()
);

export const updateTicketDescription = createAction(
    '[TICKET DESCRIPTION COMPONENT] Update Ticket Description',
    props<{ ticketId: number; note: string }>()
);
export const updateTicketDescriptionSuccess = createAction(
    '[TICKET DESCRIPTION UPDATE API] Update Ticket Description Success',
    props<{ updatedNote: string; message: string }>()
);
export const updateTicketDescriptionFailure = createAction(
    '[TICKET DESCRIPTION UPDATE API] Update Ticket Description Failure',
    props<{ error: unknown }>()
);

export const updateTicketBookedDays = createAction(
    '[TICKET BOOKEDDAYS COMPONENT] Update Ticket Booked Days',
    props<{ ticketId: number; description: string }>()
);
export const updateTicketBookedDaysSuccess = createAction(
    '[TICKET BOOKEDDAYS UPDATE API] Update Ticket Booked Days Success',
    props<{ updatedDescription: string }>()
);
export const updateTicketBookedDaysFailure = createAction(
    '[TICKET BOOKEDDAYS UPDATE API] Update Ticket Booked Days Failure',
    props<{ error: unknown }>()
);

export const loadTicketCounsels = createAction('[TICKET INFORMATION COMPONENT] Load Ticket Counsels');
export const loadTicketCounselsSuccess = createAction(
    '[TICKET INFORMATION API] Load Ticket Counsels Successfully',
    props<{ counsels: TicketCounsel[] }>()
);
export const loadTicketCounselsFailure = createAction(
    '[TICKET INFORMATION API] Load Ticket Counsels Failure',
    props<{ error: unknown }>()
);

export const loadCandidateContracts = createAction(
    '[TICKET INFORMATION COMPONENT] Load Candidate Contracts',
    props<{ candidateId: number }>()
);
export const loadCandidateContractsSuccess = createAction(
    '[TICKET INFORMATION API] Load Candidate Contracts Successfully',
    props<{ candidateContracts: TicketCandidateContract[] }>()
);
export const loadCandidateContractsFailure = createAction(
    '[TICKET INFORMATION API] Load Candidate Contracts Failure',
    props<{ error: unknown }>()
);

export const loadCandidates = createAction(
    '[TICKET CREATE COMPONENT] Load Candidates',
    props<{ query: string; subContract?: boolean }>()
);
export const loadCandidatesSuccess = createAction(
    '[TICKET CREATE API] Load Candidates Successfully',
    props<{ candidates: TicketCandidate[] }>()
);
export const loadCandidatesFailure = createAction(
    '[TICKET CREATE API] Load Candidates Failure',
    props<{ error: unknown }>()
);

export const ticketCreate = createAction(
    '[TICKET CREATE COMPONENT] Create Ticket',
    props<{ ticket: TicketCreate; openNewTab?: boolean }>()
);
export const ticketCreateSuccess = createAction(
    '[TICKET CREATE API] Create Ticket Successfully',
    props<{ tickets: number[] }>()
);
export const ticketCreateSuccessNewTab = createAction(
    '[TICKET CREATE API] Create Ticket Successfully in New Tab',
    props<{ tickets: number[] }>()
);
export const ticketCreateFailure = createAction(
    '[TICKET CREATE API] Create Ticket Failure',
    props<{ error: unknown }>()
);

export const loadTicketTypes = createAction('[TICKET INFORMATION COMPONENT] Load Ticket Types');
export const loadTicketTypesSuccess = createAction(
    '[TICKET INFORMATION API] Load Ticket Types Successfully',
    props<{ ticketTypes: OptionModel[] }>()
);
export const loadTicketTypesFailure = createAction(
    '[TICKET INFORMATION API] Load Ticket Types Failure',
    props<{ error: unknown }>()
);

export const loadTicketCategories = createAction('[TICKET INFORMATION COMPONENT] Load Ticket Categories');
export const loadTicketCategoriesSuccess = createAction(
    '[TICKET INFORMATION API] Load Ticket Categories Successfully',
    props<{ categories: TicketCategory[] }>()
);
export const loadTicketCategoriesFailure = createAction(
    '[TICKET INFORMATION API] Load Ticket Categories Failure',
    props<{ error: unknown }>()
);

export const loadTicketCategoryTypes = createAction('[TICKET INFORMATION COMPONENT] Load Ticket Category Types');
export const loadTicketCategoryTypesSuccess = createAction(
    '[TICKET INFORMATION API] Load Ticket Category Types Successfully',
    props<{ categoryTypes: TicketSettingsCategoryType[] }>()
);
export const loadTicketCategoryTypesFailure = createAction(
    '[TICKET INFORMATION API] Load Ticket Category Types Failure',
    props<{ error: unknown }>()
);

export const loadTicketSettingsCategories = createAction(
    '[TICKET INFORMATION COMPONENT] Load Ticket Settings Categories'
);
export const loadTicketSettingsCategoriesSuccess = createAction(
    '[TICKET INFORMATION API] Load Ticket Settings Categories Successfully',
    props<{ settingsCategories: TicketSettingsCategory[] }>()
);
export const loadTicketSettingsCategoriesFailure = createAction(
    '[TICKET INFORMATION API] Load Ticket Settings Categories Failure',
    props<{ error: unknown }>()
);

export const loadStates = createAction('[TICKET INFORMATION COMPONENT] Load States Items');
export const loadStatesSuccess = createAction(
    '[TICKET INFORMATION COMPONENT] Load States Items Success',
    props<{ states: CountryState[] }>()
);
export const loadStatesFailure = createAction(
    '[TICKET INFORMATION COMPONENT] Load States Items Failure',
    props<{ error: unknown }>()
);

export const loadUrgency = createAction('[TICKET INFORMATION COMPONENT] Load Urgency Items');
export const loadUrgencySuccess = createAction(
    '[TICKET INFORMATION COMPONENT] Load Urgency Items Success',
    props<{ urgency: TicketUrgency[] }>()
);
export const loadUrgencyFailure = createAction(
    '[TICKET INFORMATION COMPONENT] Load Urgency Items Failure',
    props<{ error: unknown }>()
);

export const loadTagTypes = createAction('[TICKET SETTINGS COMPONENT] Load Tag Types');
export const loadTagTypesSuccess = createAction(
    '[TICKET SETTINGS API] Load Tag Types Success',
    props<{ tagTypes: TicketTagType[] }>()
);
export const loadTagTypesFailure = createAction(
    '[TICKET SETTINGS API] Load Tag Types Failure',
    props<{ error: unknown }>()
);

export const loadTagTypesForCategory = createAction(
    '[TICKET INFORMATION COMPONENT] Load Tag Types For Category',
    props<{ categoryId: number }>()
);
export const loadTagTypesForCategorySuccess = createAction(
    '[TICKET INFORMATION API] Load Tag Types For Category Success',
    props<{ tagTypesForCategory: TicketTagType[] }>()
);
export const loadTagTypesForCategoryFailure = createAction(
    '[TICKET INFORMATION API] Load Tag Types For Category Failure',
    props<{ error: unknown }>()
);

export const addTagType = createAction('[TICKET SETTINGS COMPONENT] Add Tag Type', props<{ tagType: TicketTagType }>());
export const addTagTypeSuccess = createAction(
    '[TICKET SETTINGS API] Add Tag Type Success',
    props<{ message: string }>()
);
export const addTagTypeFailure = createAction('[TICKET SETTINGS API] Add Tag Type Failure', props<{ error: string }>());

export const updateTagType = createAction(
    '[TICKET SETTINGS COMPONENT] Update Tag Type',
    props<{ tagType: TicketTagType }>()
);
export const updateTagTypeSuccess = createAction(
    '[TICKET SETTINGS API] Update Tag Type Success',
    props<{ message: string }>()
);
export const updateTagTypeFailure = createAction(
    '[TICKET SETTINGS API] Update Tag Type Failure',
    props<{ error: string }>()
);

export const deleteTagType = createAction('[TICKET SETTINGS COMPONENT] Delete Tag Type', props<{ id: number }>());
export const deleteTagTypeSuccess = createAction(
    '[TICKET SETTINGS API] Delete Tag Type Success',
    props<{ message: string }>()
);
export const deleteTagTypeFailure = createAction(
    '[TICKET SETTINGS API] Delete Tag Type Failure',
    props<{ error: string }>()
);

export const updateTicketCounsel = createAction(
    '[TICKET INFORMATION COMPONENT] Update Ticket Counsel',
    props<{ ticketId: number; counselId: number }>()
);
export const updateTicketCounselSuccess = createAction(
    '[TICKET INFORMATION API] Update Ticket Counsel Success',
    props<{ counselId: number; message: string }>()
);
export const updateTicketCounselFailure = createAction(
    '[TICKET INFORMATION API] Update Ticket Counsel Failure',
    props<{ error: unknown }>()
);

export const loadTicketHistory = createAction(
    '[TICKET HISTORY COMPONENT] Load Ticket History By Ticket Id',
    props<{ ticketId: number }>()
);
export const loadTicketHistorySuccess = createAction(
    '[TICKET HISTORY API] Load Ticket History Success',
    props<{ history: TicketHistory[] }>()
);
export const loadTicketHistoryFailure = createAction(
    '[TICKET HISTORY API] Load Ticket History Failure',
    props<{ error: unknown }>()
);

export const updateTicketHistory = createAction(
    '[TICKET HISTORY COMPONENT] Update Ticket History',
    props<{ ticketId: number; comment: string }>()
);
export const updateTicketHistorySuccess = createAction(
    '[TICKET HISTORY API] Update Ticket History Success',
    props<{ ticketId: number; message: string }>()
);
export const updateTicketHistoryFailure = createAction(
    '[TICKET HISTORY API] Update Ticket History Failure',
    props<{ error: unknown }>()
);

export const loadTicketTasks = createAction(
    '[TICKET TASK LIST COMPONENT] Load Ticket Tasks By Ticket ID',
    props<{ ticketId: number }>()
);
export const loadTicketTasksSuccess = createAction(
    '[TICKET TASK LIST API] Load Ticket Tasks By Ticket ID Success',
    props<{ tasks: TicketTaskItem[] }>()
);
export const loadTicketTasksFailure = createAction(
    '[TICKET TASK LIST API] Load Ticket Tasks By Ticket ID Failure',
    props<{ error: unknown }>()
);

export const loadTicketTaskNoteHistory = createAction(
    '[TICKET TASK LIST COMPONENT] Load Ticket Task Note History By Ticket ID',
    props<{ ticketId: number }>()
);
export const loadTicketTaskNoteHistorySuccess = createAction(
    '[TICKET TASK LIST API] Load Ticket Task Note History By Ticket ID Success',
    props<{ noteHistory: TicketTaskItemNoteHistory[] }>()
);
export const loadTicketTaskNoteHistoryFailure = createAction(
    '[TICKET TASK LIST API] Load Ticket Task Note History By Ticket ID Failure',
    props<{ error: unknown }>()
);

export const updateTicketUnitName = createAction(
    '[TICKET DETAILS AngularJS] Update Ticket Unit Name',
    props<{ unitName: string }>()
);
export const updateTicketUnitId = createAction(
    '[TICKET DETAILS AngularJS] Update Ticket Unit Id',
    props<{ unitId: number }>()
);

export const loadContract = createAction('[TICKET INFORMATION COMPONENT] Load Contract', props<{ ticketId: number }>());
export const loadContractSuccess = createAction(
    '[TICKET INFORMATION API] Load Contract Success',
    props<{ contract: TicketContract }>()
);
export const loadContractFailure = createAction(
    '[TICKET INFORMATION API] Load Contract Failure',
    props<{ error: unknown }>()
);

export const loadContractLookup = createAction('[TICKET INFORMATION COMPONENT] Load Contract Lookup');
export const loadContractLookupSuccess = createAction(
    '[TICKET INFORMATION API] Load Contract Lookup Success',
    props<{ contractLookup: TicketContractLookups }>()
);
export const loadContractLookupFailure = createAction(
    '[TICKET INFORMATION API] Load Contract Lookup Failure',
    props<{ error: unknown }>()
);

export const loadContractDetails = createAction(
    '[TICKET INFORMATION COMPONENT] Load Contract Details',
    props<{ contractId: string }>()
);
export const loadContractDetailsSuccess = createAction(
    '[TICKET INFORMATION API] Load Contract Details Success',
    props<{ travelContract: TravelContract }>()
);
export const loadContractDetailsFailure = createAction(
    '[TICKET INFORMATION API] Load Contract Details Failure',
    props<{ error: unknown }>()
);

export const createTicketCategory = createAction(
    '[TICKET DETAILS COMPONENT] Create Ticket Category',
    props<{
        categoryTypeId: number;
        defaultAssigneeId: number | null;
        name: string;
        parentCategoryId: number | null;
        isAutoLock: boolean;
    }>()
);
export const createTicketCategorySuccess = createAction(
    '[TICKET DETAILS COMPONENT] Create Ticket Category Success',
    props<{ id: number; message: string }>()
);
export const createTicketCategoryFailure = createAction(
    '[TICKET DETAILS COMPONENT] Create Ticket Category Failure',
    props<{ error: unknown }>()
);
export const editTicketCategory = createAction(
    '[TICKET DETAILS COMPONENT] Edit Ticket Category',
    props<{
        id: number;
        categoryTypeId: number;
        defaultAssigneeId: number | null;
        name: string;
        parentCategoryId: number | null;
        isAutoLock: boolean;
    }>()
);
export const editTicketCategorySuccess = createAction(
    '[TICKET DETAILS COMPONENT] Edit Ticket Category Success',
    props<{ id: number; message: string }>()
);
export const editTicketCategoryFailure = createAction(
    '[TICKET DETAILS COMPONENT] Edit Ticket Category Failure',
    props<{ error: unknown }>()
);
export const deleteTicketCategory = createAction(
    '[TICKET DETAILS COMPONENT] Delete Ticket Category',
    props<{ id: number }>()
);
export const deleteTicketCategorySuccess = createAction(
    '[TICKET DETAILS API] Delete Ticket Category Success',
    props<{ message: string }>()
);
export const deleteTicketCategoryFailure = createAction(
    '[TICKET DETAILS API] Delete Ticket Category Failure',
    props<{ error: unknown }>()
);
export const createTicketSubCategory = createAction(
    '[TICKET DETAILS COMPONENT] Create Ticket Sub Category',
    props<{
        categoryTypeId: number;
        defaultAssigneeId: number | null;
        name: string;
        parentCategoryId: number | null;
        isAutoLock: boolean;
    }>()
);
export const createTicketSubCategorySuccess = createAction(
    '[TICKET DETAILS COMPONENT] Create Ticket Sub Category Success',
    props<{ id: number; message: string }>()
);
export const createTicketSubCategoryFailure = createAction(
    '[TICKET DETAILS COMPONENT] Create Ticket Sub Category Failure',
    props<{ error: unknown }>()
);
export const editTicketSubCategory = createAction(
    '[TICKET DETAILS COMPONENT] Edit Ticket Sub Category',
    props<{
        id: number;
        categoryTypeId: number;
        defaultAssigneeId: number | null;
        name: string;
        parentCategoryId: number | null;
        isAutoLock: boolean;
    }>()
);
export const editTicketSubCategorySuccess = createAction(
    '[TICKET DETAILS COMPONENT] Edit Ticket Sub Category Success',
    props<{ id: number; message: string }>()
);
export const editTicketSubCategoryFailure = createAction(
    '[TICKET DETAILS COMPONENT] Edit Ticket Sub Category Failure',
    props<{ error: unknown }>()
);

export const updateTicketUpdatingFlag = createAction(
    '[TICKET INFORMATION COMPONENT] Update Ticket Updating Flag',
    props<{ updateFlag: boolean }>()
);
export const searchEmployees = createAction(
    '[TICKET TASK DIALOG COMPONENT] Search Employees',
    props<{ query: string }>()
);
export const searchEmployeesSuccess = createAction(
    '[TICKET SEARCH EMPLOYEES API] Search Employees Success',
    props<{ employees: TicketEmployee[] }>()
);
export const searchEmployeesFailure = createAction(
    '[TICKET SEARCH EMPLOYEES API] Search Employees Failure',
    props<{ error: unknown }>()
);

export const clearEmployees = createAction('[TICKET SEARCH EMPLOYEES API] Clear Employees');

export const loadTicketAttachments = createAction(
    '[TICKET ATTACHMENTS COMPONENT] Load Ticket Attachments',
    props<{ ticketId: number }>()
);
export const loadTicketAttachmentsSuccess = createAction(
    '[TICKET ATTACHMENTS API] Load Ticket Attachments Successfully',
    props<{ ticketAttachments: TicketAttachments[] }>()
);
export const loadTicketAttachmentsFailure = createAction(
    '[TICKET ATTACHMENTS API] Load Ticket Attachments Failure',
    props<{ error: unknown }>()
);

// Attachments
export const uploadAttachment = createAction(
    '[TICKET ATTACHMENT AngularJs] Upload Ticket Attachment File',
    props<{ ticketId: number; files: TicketFilesUpload[] }>()
);
export const updateAttachment = createAction(
    '[TICKET ATTACHMENT AngularJs] Update Ticket Attachment File',
    props<{ ticketId: number; files: TicketFilesUpload[]; attachmentId: number }>()
);
export const uploadAttachmentSuccess = createAction(
    '[TICKET ATTACHMENT AngularJs] Upload Ticket Attachment File Success',
    props<{ ticketId: number; message: string }>()
);
export const uploadAttachmentFailure = createAction(
    '[TICKET ATTACHMENT AngularJs] Upload Ticket Attachment File Failure',
    props<{ error: unknown }>()
);
export const deleteAttachment = createAction(
    '[TICKET ATTACHMENT AngularJs] Delete Ticket Attachment File',
    props<{ ticketId: number; attachmentId: number }>()
);
export const deleteAttachmentSuccess = createAction(
    '[TICKET ATTACHMENT AngularJs] Delete Ticket Attachment File Success',
    props<{ ticketId: number; message: string }>()
);
export const deleteAttachmentFailure = createAction(
    '[TICKET ATTACHMENT AngularJs] Delete Ticket Attachment File Failure',
    props<{ error: unknown }>()
);

export const createTask = createAction(
    '[TICKET TASK DIALOG COMPONENT] Create task',
    props<{ ticketId: number; description: string; dueDate: Date; assigneeId: number }>()
);
export const createTaskSuccess = createAction(
    '[TICKET CREATE TASK API] Create task Success',
    props<{ ticketId: number; message: string }>()
);
export const createTaskFailure = createAction(
    '[TICKET CREATE TASK API] Create task Failure',
    props<{ error: unknown }>()
);

export const updateTask = createAction(
    '[TICKET TASK DIALOG COMPONENT] Update Task',
    props<{ updateArgs: TaskUpdateRequest }>()
);
export const updateTaskSuccess = createAction(
    '[TICKET UPDATE TASK API] Update Task Success',
    props<{ ticketId: number; message: string }>()
);
export const updateTaskFailure = createAction(
    '[TICKET UPDATE TASK API] Update Task Failure',
    props<{ error: unknown }>()
);

export const updateTaskNote = createAction(
    '[TICKET TASK REVIEW DIALOG COMPONET] Update Task Note',
    props<{ update: TaskUpdateRequest }>()
);
export const updateTaskNoteSuccess = createAction(
    '[TICKET UPDATE TASK NOTE API] Update Task Note Successfully',
    props<{ ticketId: number; message: string }>()
);
export const updateTaskNoteFailure = createAction(
    '[TICKET UPDATE TASK NOTE API] Update Task Note Failure',
    props<{ error: unknown }>()
);

export const reassignTickets = createAction(
    '[TICKET REASSIGN DIALOG COMPONENT] Reassign Tickets By IDs',
    props<{ assigneeId: number; ticketIds: number[] }>()
);
export const reassignTicketsSuccessfully = createAction(
    '[TICKET REASSIGN DIALOG API] Reassign Tickets By IDs Successfully'
);
export const reassignTicketsFailure = createAction(
    '[TICKET REASSIGN DIALOG API] Reassign Tickets By IDs Failure',
    props<{ error: unknown }>()
);

export const reassignTicket = createAction(
    '[TICKET REASSIGN DIALOG COMPONENT] Reassign Ticket By ID',
    props<{ assigneeId: number; ticketId: number }>()
);
export const reassignTicketSuccess = createAction(
    '[TICKET REASSIGN DIALOG API] Reassign Ticket By ID Successfully',
    props<{ ticketId: number }>()
);
export const reassignTicketFailure = createAction(
    '[TICKET REASSIGN DIALOG API] Reassign Ticket By ID Failure',
    props<{ error: unknown }>()
);

export const closeTicket = createAction(
    '[TICKET CLOSE MODAL COMPONENT] Close ticket',
    props<{ ticketId: number; closeParams: unknown }>()
);
export const closeTicketSuccess = createAction(
    '[TICKET CLOSE API] Close ticket Success',
    props<{ ticketId: number }>()
);
export const closeTicketFailure = createAction('[TICKET CLOSE API] Close ticketFailure', props<{ error: unknown }>());

export const reopenTicket = createAction(
    '[TICKET DETAIL COMPONENT] Reopen ticket',
    props<{ ticketId: number; reopenParams: unknown }>()
);
export const reopenTicketSuccess = createAction(
    '[TICKET REOPEN API] Reopen ticket Success',
    props<{ ticketId: number }>()
);
export const reopenTicketFailure = createAction(
    '[TICKET REOPEN API] Reopen ticketFailure',
    props<{ error: unknown }>()
);

export const updateTicket = createAction(
    '[TICKET DETAIL COMPONENT] Update ticket',
    props<{ ticketId: number; updateData: unknown }>()
);
export const updateTicketSuccess = createAction(
    '[TICKET UPDATE API] Update ticket Success',
    props<{ ticketId: number; message: string }>()
);
export const updateTicketFailure = createAction(
    '[TICKET UPDATE API] Update ticketFailure',
    props<{ error: unknown }>()
);

export const clearTicketDetails = createAction('[TICKET DETAILS COMPONENT] Clear Ticket Details');

export const toggleTicketLockStatus = createAction(
    '[TICKET DETAILS COMPONENT] Toggle Ticket Lock Status',
    props<{ ticketId: number }>()
);
export const toggleTicketLockStatusSuccess = createAction(
    '[TICKET DETAILS COMPONENT] Toggle Ticket Lock Status Success',
    props<{ ticketId: number; message: string }>()
);
export const toggleTicketLockStatusFailure = createAction(
    '[TICKET DETAILS COMPONENT] Toggle Ticket Lock Status Failure',
    props<{ error: unknown }>()
);

export const createStaffingAdvisoryFromTicket = createAction(
    '[TICKET DETAILS COMPONENT] Create Ticket Advisory From Ticket',
    props<{ request: StaffingAdvisoryFromTicketRequest }>()
);
export const createStaffingAdvisoryFromTicketSuccess = createAction(
    '[TICKET DETAILS COMPONENT] Create Ticket Advisory From Ticket Success',
    props<{ id: number; message: string; ticketId: number }>()
);
export const createStaffingAdvisoryFromTicketFailure = createAction(
    '[TICKET DETAILS COMPONENT] Create Ticket Advisory From Ticket Failure',
    props<{ error: unknown }>()
);
